/*Post message event types*/
export const ADD_SP_METADATA_SAVED = "add_sp_metadata_saved";
export const ANY_ORIGIN = "*";
export const APP_LOADED = "app_loaded";
export const CANCEL_ADD_SAML = "cancel_add_saml";
export const MESSAGE_EVENT_TYPE = "message"

/*Content types for HTTP requests*/
export const APPLICATION_JSON_CONTENT_TYPE = "application/json";

/*HTTP methods for requests*/
export const POST = "post";
export const GET = "get";

/*Session storage items labels*/
export const AUTH_SESSION_TOKEN = "authSessionToken";
export const APPLIANCE_URL = "applianceUrl";
export const MAPPED_CAPABILITIES = "mappedCapabilities";
